import cn from 'classnames';
import styles from './ThumbLikeButton.module.scss';

type ThumbLikeButtonProps = {
  className?: string;
  count: number;
  onClick: () => void;
  isFilled?: boolean;
};

export function ThumbLikeButton({
  className,
  count,
  onClick,
  isFilled = false,
}: ThumbLikeButtonProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName} onClick={onClick}>
      <img
        src={isFilled ? '/svg/thumb-up-filled.svg' : '/svg/thumb-up.svg'}
        alt="thumb-up"
        className={styles.icon}
      />
      {count > 0 && <span className={styles.count}>{count}</span>}
    </div>
  );
}
